export enum ExperienceVerificationStatusType {
    Submitted = 0,
    Verified = 1,
    UnableToVerify = 2,
    Rejected = 3,
}

export const ExperienceVerificationStatusTypeOptions = [
    {
        id: ExperienceVerificationStatusType.Submitted,
        name: 'Submitted',
    },
    {
        id: ExperienceVerificationStatusType.Verified,
        name: 'Verified',
    },
    {
        id: ExperienceVerificationStatusType.UnableToVerify,
        name: 'Unable to Verify',
    },
    {
        id: ExperienceVerificationStatusType.Rejected,
        name: 'Rejected',
    },
];
